import { render, staticRenderFns } from "./Species.vue?vue&type=template&id=4edc9810"
import script from "./Species.vue?vue&type=script&lang=js"
export * from "./Species.vue?vue&type=script&lang=js"
import style0 from "./Species.vue?vue&type=style&index=0&id=4edc9810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports